import { Tabs, TabsList, TabsTrigger } from "../ui/tabs";
import {
  Plus,
  BookOpen,
  Calendar,
  Users,
  FolderOpen,
  Search,
  Backpack,
} from "lucide-react";

const TABS = [
  { id: "creation", label: "Création", icon: Plus, mobileLabel: "Créer" },
  { id: "matieres", label: "Matières", icon: BookOpen, mobileLabel: "Matières" },
  { id: "journal", label: "Cahier-journal", icon: Calendar, mobileLabel: "Journal" },
  { id: "classe", label: "Gestion classe", icon: Users, mobileLabel: "Classe" },
  { id: "cartable", label: "Cartable", icon: Backpack, mobileLabel: "Cartable" },
  { id: "ressources", label: "Mes ressources", icon: FolderOpen, mobileLabel: "Ressources" },
  { id: "partage", label: "Ressources partagées", icon: Search, mobileLabel: "Partage" },
];

export function TeacherHubTabs({ activeTab, onTabChange }) {
  return (
    <div className="bg-white border-b border-slate-100 sticky top-[65px] z-40">
      <div className="max-w-7xl mx-auto">
        {/* Desktop Tabs */}
        <div className="hidden md:block">
          <Tabs value={activeTab} onValueChange={onTabChange}>
            <TabsList className="w-full h-auto p-1 bg-transparent justify-start gap-1 overflow-x-auto">
              {TABS.map((tab) => (
                <TabsTrigger
                  key={tab.id}
                  value={tab.id}
                  data-testid={`tab-${tab.id}`}
                  className="flex items-center gap-2 px-4 py-2.5 data-[state=active]:bg-indigo-50 data-[state=active]:text-indigo-700 data-[state=active]:shadow-none rounded-lg font-medium transition-colors"
                >
                  <tab.icon className="w-4 h-4" />
                  <span>{tab.label}</span>
                </TabsTrigger>
              ))}
            </TabsList>
          </Tabs>
        </div>

        {/* Mobile Tabs - Scrollable */}
        <div className="md:hidden overflow-x-auto scrollbar-hide">
          <div className="flex gap-1 p-2 min-w-max">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                data-testid={`tab-mobile-${tab.id}`}
                onClick={() => onTabChange(tab.id)}
                className={`flex flex-col items-center gap-1 px-3 py-2 rounded-lg transition-colors min-w-[70px] ${
                  activeTab === tab.id
                    ? "bg-indigo-50 text-indigo-700"
                    : "text-slate-600 hover:bg-slate-50"
                }`}
              >
                <tab.icon className="w-5 h-5" />
                <span className="text-xs font-medium">{tab.mobileLabel}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export { TABS };
